import React, { memo } from 'react';
import { RegisterMenuForm } from '../../organisms/menu/RegisterMenuForm';
import { useParams } from 'react-router-dom';
import { useRegisterMenuImages } from '../../../hooks/menu/useRegisterMenuImages';


export const DrinkMenuRegister: React.FC = memo(() => {
  const { restaurantId } = useParams()
  const onSubmit = useRegisterMenuImages('drink', restaurantId)
  return <RegisterMenuForm menuName='ドリンク' onSubmit={onSubmit} />;
});